import { useTranslation as useI18nextTranslation, UseTranslationOptions } from "react-i18next";
import { HOST_LANGUAGES, SupportedLanguage } from "../i18n/languages";

// The union ("sk" | "en" | "cs" | "de" | "it" | "pl") lives in shared/i18n/languages.ts with
// the per-host list; re-exported so every existing `import { SupportedLanguage }` still works.
export type { SupportedLanguage };

export type TranslationNamespace = "common" | "account" | "settings" | "public" | "layout" | "myMachinery" | "marketplace" | "inventory" | "servicing" | "serviceBoard" | "serviceOffers" | "partnerHub" | "chatBot" | "partnerships" | "serviceTracking" | "operations" | "machineEvidence" | "errors";

export const useTranslation = (ns?: TranslationNamespace | TranslationNamespace[], options?: UseTranslationOptions<any>) => {
  const { t: translate, i18n, ready } = useI18nextTranslation(ns, options);

  const changeLanguage = (lng: SupportedLanguage) => {
    return i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = (): SupportedLanguage => {
    return i18n.language as SupportedLanguage;
  };

  /** This host's languages in menu order sk, en, cs, de, it, pl — exactly core/i18n.ts `supportedLngs`. */
  const getSupportedLanguages = (): SupportedLanguage[] => {
    return [...HOST_LANGUAGES];
  };

  return {
    translate,
    i18n,
    ready,
    changeLanguage,
    getCurrentLanguage,
    getSupportedLanguages,
    isReady: ready
  };
};

export default useTranslation; 